import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { FeatureToggleModule } from '@mynexus/mynexus-ui-lib';
import { FeatureFlags } from '@core/enumeration';
import { MfeCoreModule } from '@mynexus/mfe-core';
import { Router } from '@angular/router';
import { NotificationActions } from '@feature/notifications/actions';
import { AuthenticationService } from '@core/service';


@Component({
    selector: 'mnc-app-notifications',
    templateUrl: './notifications.component.html',
    imports: [MfeCoreModule, FeatureToggleModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NotificationsComponent {
  protected readonly FeatureFlags = FeatureFlags;
  private readonly router = inject(Router);
  private readonly authenticationService = inject(AuthenticationService);

  // Temporary flag as notifications should be a global cross product feature
  notificationsVisible = this.authenticationService.isPACOperations || this.authenticationService.isPACOperationsAdmin;

  private handleViewAllNotifications() {
    this.router.navigate(['/notifications']);
  }

  private handleNotificationClick(event: CustomEvent) {
    const notification = event.detail;
    const { actionFn } = NotificationActions[notification.name];

    if (actionFn) {
      actionFn(this.router, notification.payload);
    }
  }
}

